import Axios from '../../../Utils/axios';
import { SYSTEM_CODE } from '../../../Utils/enums';
import { getURL } from './commonApi';

const globals = require('../../../config/' +
  process.env.REACT_APP_STAGE +
  '/Portal/globals');

//Invoice 상세조회
const getInvoice = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/invoice/invoice/${param.uniqueInvoiceId}`
  );
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Invoice Correction 상세조회
const getCopyCorrectionInvoiceDetail = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/invoice/invoice/issue/${param.uniqueInvoiceId}`
  );
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Invoice 조회 List
const getInvoiceList = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/invoice`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//InvoiceList totalAmount 조회
const getInvoiceListTotalAmount = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/invoice/totalamount`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//InvoiceList mail정보 포함 조회
const getInvoiceEmailHistory = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/invoice/mail`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Invoice mail 재전송
const postInvoiceEmailResend = (param) => {
  // url 수정 필요
  const url = globals.exApiUrl + '/invoice/send/mail/secure';
  return Axios.post(url, param).then((response) => {
    return response;
  });
};

//InvoiceTemp 상세조회
const getInvoiceTemp = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/temp/${param.invoiceNo}`);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//InvoiceTemp list 조회
const getInvoiceTempList = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/temp`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//InvoiceTempList 삭제
const deleteInvoiceTempList = (param) => {
  const url = `${globals.exApiUrl}/invoice/temp?invoiceNo=` + param;
  return Axios.delete(url).then((response) => {
    return response;
  });
};

//InvoiceTempList totalAmount 조회
const getInvoiceTempListTotalAmount = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/temp/totalamount`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Invoice issue(발행)
const setInvoiceIssue = (param) => {
  const url = globals.exApiUrl + '/invoice/invoice/issue';
  return Axios.post(url, param).then((response) => {
    return response;
  });
};

// Single Issuance 임시저장
const setInvoiceTempList = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/temp`);
  return Axios.post(url, param).then((response) => {
    return response;
  });
};

//InvoicePos 상세조회
const getInvoicePos = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/invoice/pos/${param.uniqueInvoiceId}`
  );
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Invoice Pos 조회 List
const getInvoicePosList = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/pos`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//InvoicePosList totalAmount 조회
const getInvoicePosListTotalAmount = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/pos/totalamount`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Massive Issuance Verification Result 조회
const getMassiveIssuanceVerificationResult = () => {
  const url = getURL(`${globals.exApiUrl}/invoice/temp/massiveIssuance`);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Massive Issuance 발급
const updateMassiveIssuance = (param) => {
  const url = getURL(`${globals.exApiUrl}/invoice/temp/massiveIssuance`);
  return Axios.put(url, param).then((response) => {
    return response;
  });
};

/********************************************************************************/

//거래처 조회 리스트
const getClientList = (param) => {
  const url = getURL(`${globals.exApiUrl}/trade`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//거래처 리스트 추가
const insertClientList = (param) => {
  const url = globals.exApiUrl + '/trade';
  return Axios.post(url, param).then((response) => {
    return response;
  });
};

//거래처 리스트 삭제
const deleteClientList = (param) => {
  const url = `${globals.exApiUrl}/trade?tradeNo=` + param;
  return Axios.delete(url, param).then((response) => {
    return response;
  });
};

//거래처 수정
const updateClient = (param) => {
  const url = `${globals.exApiUrl}/trade`;
  return Axios.put(url, param).then((response) => {
    return response;
  });
};

const isClient = (param) => {
  // const url = `${globals.exApiUrl}/trade/tin`;
  const url = getURL(`${globals.exApiUrl}/trade/tin`, param);
  return Axios.get(url, param).then((response) => {
    return response;
  });
};

const tradeRegisteredNameCheck = (param) => {
  const url = getURL(`${globals.exApiUrl}/trade/nameCheck`, param);
  return Axios.get(url, param).then((response) => {
    return response;
  });
};

const tradeTinCheck = (param) => {
  const url = getURL(`${globals.exApiUrl}/trade/tin`, param);
  return Axios.get(url, param).then((response) => {
    return response;
  });
};

const tradeCloseCheck = (param) => {
  const url = getURL(`${globals.exApiUrl}/trade/close`, param);
  return Axios.get(url, param).then((response) => {
    return response;
  });
};

//품목 조회 리스트
const getItemList = (param) => {
  const url = getURL(`${globals.exApiUrl}/item`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//품목 리스트 추가
const insertItemList = (param) => {
  const url = globals.exApiUrl + '/item';
  return Axios.post(url, param).then((response) => {
    return response;
  });
};

//품목 삭제
const deleteItemList = (param) => {
  const url = `${globals.exApiUrl}/item?itemNo=` + param;
  return Axios.delete(url, param).then((response) => {
    return response;
  });
};

//거래처 수정
const updateItem = (param) => {
  const url = `${globals.exApiUrl}/item`;
  return Axios.put(url, param).then((response) => {
    return response;
  });
};

const itemNameCheck = (param) => {
  const url = getURL(`${globals.exApiUrl}/item/nameCheck`, param);
  return Axios.get(url, param).then((response) => {
    return response;
  });
};

//Statistics sum
const getStatisticsSum = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/sum`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Statistics sum detail
const getStatisticsSumDetail = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/sum/detail`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Statistics sum popup
const getStatisticsSumPopup = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/sum/popup`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Statistics period
const getStatisticsPeriod = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/period`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Statistics period detail
const getStatisticsPeriodDetail = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/period/detail`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Statistics period popup
const getStatisticsPeriodPopup = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/period/popup`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//Statistics type
const getStatisticsType = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/type`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//StatisticsPosCrm sum
const getStatisticsPosCrmSum = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/poscrm/sum`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//StatisticsPosCrm sum detail
const getStatisticsPosCrmSumDetail = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/poscrm/sum/detail`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//StatisticsPosCrm sum popup
const getStatisticsPosCrmSumPopup = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/poscrm/sum/popup`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//StatisticsPosCrm period
const getStatisticsPosCrmPeriod = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/poscrm/period`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//StatisticsPosCrm period detail
const getStatisticsPosCrmPeriodDetail = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/statistics/poscrm/period/detail`,
    param
  );
  return Axios.get(url).then((response) => {
    return response;
  });
};

//StatisticsPosCrm period popup
const getStatisticsPosCrmPeriodPopup = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/statistics/poscrm/period/popup`,
    param
  );
  return Axios.get(url).then((response) => {
    return response;
  });
};

//StatisticsPosCrm type
const getStatisticsPosCrmType = (param) => {
  const url = getURL(`${globals.exApiUrl}/statistics/poscrm/type`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

//JWS Viewer
const getJWS = (param) => {
  const url = `${globals.exApiUrl}/invoice/invoice/jws/verification`;
  return Axios.post(url, param).then((response) => {
    return response;
  });
};

// Inquiry list of VAT return(Monthly)
const getVatMonthlyList = (param) => {
  const url = getURL(`${globals.exApiUrl}/M2550/search/`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

// Inquiry Detail of VAT return(Monthly)
const getVatMonthlyDetail = (param) => {
  const url = getURL(`${globals.exApiUrl}/M2550`, param);
  return Axios.get(url).then((response) => {
    return response;
  });
};

// Inquiry list of VAT return(Quarterly)
const getVatQuarterlyList = (param) => {
  const url = getURL(`${globals.exApiUrl}/Q2550/search/`, param);

  return Axios.get(url).then((response) => {
    return response;
  });
};

// Inquiry Detail ist of VAT return(Quarterly)
const getVatQuarterlyDetail = (param) => {
  const url = getURL(`${globals.exApiUrl}/Q2550`, param);

  return Axios.get(url).then((response) => {
    return response;
  });
};

export default {
  getInvoice,
  getCopyCorrectionInvoiceDetail,
  getInvoiceList,
  getInvoiceListTotalAmount,
  getInvoiceEmailHistory,
  postInvoiceEmailResend,
  getInvoiceTemp,
  getInvoiceTempList,
  getInvoiceTempListTotalAmount,
  setInvoiceIssue,
  deleteInvoiceTempList,

  getInvoicePos,
  getInvoicePosList,
  getInvoicePosListTotalAmount,

  getMassiveIssuanceVerificationResult,
  updateMassiveIssuance,

  getClientList,
  insertClientList,
  deleteClientList,
  updateClient,
  isClient,
  tradeTinCheck,
  tradeCloseCheck,
  tradeRegisteredNameCheck,

  getItemList,
  insertItemList,
  deleteItemList,
  updateItem,
  itemNameCheck,

  setInvoiceTempList,

  getStatisticsSum,
  getStatisticsSumDetail,
  getStatisticsSumPopup,
  getStatisticsPeriod,
  getStatisticsPeriodDetail,
  getStatisticsPeriodPopup,
  getStatisticsType,

  getStatisticsPosCrmSum,
  getStatisticsPosCrmSumDetail,
  getStatisticsPosCrmSumPopup,
  getStatisticsPosCrmPeriod,
  getStatisticsPosCrmPeriodDetail,
  getStatisticsPosCrmPeriodPopup,
  getStatisticsPosCrmType,

  getJWS,

  getVatMonthlyList,
  getVatMonthlyDetail,
  getVatQuarterlyList,
  getVatQuarterlyDetail,
};
